import { useContextHierarchyFilter } from '../components/tabs/planningByLevel/components/mainHierarchyFilter/context/ContextHierarchyFilter';

export const useHierarchyFilters = () => {
	return useContextHierarchyFilter();
};
